import _ from "lodash";
export function getPageTitle(page: any, language: any) {
  return (
    (page.translations &&
      page.translations[language] &&
      page.translations[language].title) ||
    page.title
  );
}

export function getPageGroupTitle(group: any, language: any) {
  return group.translations && group.translations[language]
    ? group.translations[language]
    : group.group;
}

export function calculateActivePage(pages: any) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let pageState: any = null;

  // make sure the pages are sorted by order ASC
  const sortedPages = _.sortBy(pages, (p: any) => p.order);

  //  looks for the active page state
  const findActivePageState = (ps: any) => ps.active;
  const activePage = sortedPages.find((p: any) =>
    p.pagesStates.find(findActivePageState)
  );

  if (activePage) {
    pageState = activePage.pagesStates.find(findActivePageState);
    return pageState;
  }

  // looks the for first incomplete page state
  const findIncompletePageSate = (ps: any) => !ps.finished;
  const incompletePage = sortedPages.find((p: any) =>
    p.pagesStates.find(findIncompletePageSate)
  );

  if (incompletePage) {
    pageState = incompletePage.pagesStates.find(findIncompletePageSate);
    return pageState;
  }

  // otherwise the latest page state of the first page
  const firstPage = sortedPages[0];

  pageState = _.sortBy(
    firstPage?.pagesStates || [],
    (ps: any) => ps.createdAt
  ).pop();
  return pageState;
}

export const scrollToTop = () => {
  window.scrollTo(0, 0);
}
